export default __webpack_public_path__ + "static/media/refresh512.ee07186c.png";